import React from "react";
var __jsx = React.createElement;
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import FlowOption from "@/pages/sell-my-car/components/FlowOption";
import FlowOptionBody from "@/pages/sell-my-car/components/FlowOptionBody";
import FlowStepTitle from "@/pages/sell-my-car/components/FlowStepTitle";
import FlowSearchBar from "@/pages/sell-my-car/components/FlowSearchBar";
import { useTranslation } from "@i18n";
import { useCallback, useState } from "react";
import FlowScreenHeaderSpacing from "@/pages/sell-my-car/components/FlowScreenHeaderSpacing";
import FlowScreenBodySpacing from "@/pages/sell-my-car/components/FlowScreenBodySpacing";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowZeroResult from "@/pages/sell-my-car/components/FlowZeroResult";
import useBoolean from "@hooks/useBoolean";
import { If } from "@componentsShared/Conditional/If";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
import { useLang } from "@/common/Contexts/LanguageContext";
var CarTrimScreen = function CarTrimScreen() {
  var _state$availableExten;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(null),
    filteredExtensions = _useState[0],
    setFilteredExtensions = _useState[1];
  var _useState2 = useState(null),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var loading = useBoolean(true);
  var lang = useLang();
  var handleExtensionSelect = function handleExtensionSelect(extension) {
    actions.selectExtension(extension);
    navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_YEAR);
  };
  var searchExtensionsWrapper = useCallback(function (_items, searchTerm, limit) {
    setSearchTerm(searchTerm);
    return actions.searchExtensions(searchTerm, limit);
  }, [actions.searchModels]);
  var handleSearchResults = useCallback(function (results) {
    setFilteredExtensions(results);
    setTimeout(function () {
      loading.setFalse();
    }, 300);
  }, []);
  if (!state.selection.model) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-red-500"
    }, "Please select a model first"));
  }
  if (state.availableExtensions.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4"
    }, /*#__PURE__*/React.createElement("p", null, "No trims available for ", state.selection.model.name));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-trim-screen",
    className: "flex flex-col h-full md:pb-6"
  }, /*#__PURE__*/React.createElement(FlowScreenHeaderSpacing, null, /*#__PURE__*/React.createElement(FlowStepTitle, null, tShort("sell_trade_v2/choose_trim", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(FlowSearchBar, {
    id: "trim-search",
    options: state.availableExtensions || [],
    searchFunction: searchExtensionsWrapper,
    onSearch: handleSearchResults,
    onSelect: handleExtensionSelect,
    limit: 200,
    getItemKey: function getItemKey(make) {
      return make.id;
    },
    placeholder: tShort("sell_trade_v2/search_brands_placeholder", {
      ns: "web_sell_trade"
    }),
    showResults: false,
    className: ((_state$availableExten = state.availableExtensions) === null || _state$availableExten === void 0 ? void 0 : _state$availableExten.length) > 8 ? "" : "hidden"
  })), /*#__PURE__*/React.createElement(FlowScreenBodySpacing, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (state === null || state === void 0 ? void 0 : state.isLoading) || loading.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowOptionLoading, null)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (filteredExtensions === null || filteredExtensions === void 0 ? void 0 : filteredExtensions.length) !== 0
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-trim-list",
    className: "flex flex-col gap-3 md:grid md:grid-cols-6 md:gap-8",
    dir: lang == 'ar' ? 'rtl' : 'ltr'
  }, filteredExtensions === null || filteredExtensions === void 0 ? void 0 : filteredExtensions.map(function (ext) {
    var _state$selection, _state$selection$make;
    return /*#__PURE__*/React.createElement(FlowOption, {
      key: ext.id,
      id: "sell-car-trim-option-".concat(ext.id),
      onClick: function onClick() {
        return handleExtensionSelect(ext);
      }
    }, /*#__PURE__*/React.createElement(FlowOptionBody, {
      name: ext.name,
      imgUrl: state === null || state === void 0 ? void 0 : (_state$selection = state.selection) === null || _state$selection === void 0 ? void 0 : (_state$selection$make = _state$selection.make) === null || _state$selection$make === void 0 ? void 0 : _state$selection$make.logo
    }));
  }))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: filteredExtensions !== null && searchTerm !== null
  }, /*#__PURE__*/React.createElement(FlowZeroResult, {
    searchTerm: searchTerm
  }))))))));
};
export default CarTrimScreen;